import { useState, useEffect } from "react";
import {
  FaSignInAlt,
  FaSignOutAlt,
  FaUser,
  FaDollarSign,
  FaList,
  FaHome,
  FaBell,
  FaSearch,
  FaTimes,
} from "react-icons/fa";
import { FaBars } from "react-icons/fa";
import { useNavigate, NavLink } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout, reset } from "../../features/auth/authSlice.js";
import { toggleMenu, closeMenu } from "../../features/utils/menuSlice.js";
import { FaRegUserCircle } from "react-icons/fa";
import RandomColorCircle from "../utils/RandomColorCircle.js";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import Dropdown from "react-bootstrap/Dropdown";
import logo from "../../assets/budget_logo_b.svg";
import { parseDate } from "../utils/dateParser";
import SchedaSearchBar from "./SchedaSearchBar";
import {
  getNotifications,
  markNotificationRead,
  markAllNotificationsRead,
} from "../../features/notifications/notificationSlice";

const NOTIFICATIONS_POLL_MS = 60 * 60 * 1000;

function Header() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { notifications, unreadCount } = useSelector((state) => state.notifications);
  const [searchOpen, setSearchOpen] = useState(false);

  const onLogout = () => {
    dispatch(logout());
    dispatch(reset());
    navigate("/");
  };

  useEffect(() => {
    if (!user) return;
    dispatch(getNotifications());
    const interval = setInterval(() => dispatch(getNotifications()), NOTIFICATIONS_POLL_MS);
    return () => clearInterval(interval);
  }, [user, dispatch]);

  return (
    <>
      <nav
        className="navbar navbar-main navbar-expand-lg px-0 shadow-none border-radius-xl"
        id="navbarBlur"
        data-scroll="true"
      >
        <div className="container-fluid py-3">
          <div className="d-flex align-items-center gap-3">
            <ul className="navbar-nav d-flex flex-row m-0">
              <li
                role="button"
                className="d-flex flex-column justify-content-center align-items-center d-xl-none nav-link"
                onClick={() => dispatch(toggleMenu())}
              >
                <FaBars size="18" className="text-body p-0" />
                {/* <small>Menu</small> */}
              </li>
            </ul>
            {/* Mobile-only brand mark, next to the hamburger — the sidebar's own
                logo already covers desktop. Hidden while search is expanded,
                to give the input room. */}
            <img
              src={logo}
              alt="Budget"
              className={searchOpen ? "d-none" : "d-xl-none"}
              style={{ height: "22px" }}
            />
          </div>
          {/* da fare un componente di breadcrumbs */}
          {/* <nav aria-label="breadcrumb">
            <ol className="breadcrumb bg-transparent mb-0 pb-0 pt-0 px-0">
            <li className="breadcrumb-item text-sm">
              <NavLink className="text-decoration-none opacity-5 text-dark" to='/'>Home</NavLink>
            </li>
          </ol> 
          </nav>*/}
          {/* da fare un componente di breadcrumbs */}
          {user && (
            <div
              className={
                searchOpen
                  ? "d-flex flex-grow-1 justify-content-center align-items-center px-3"
                  : "d-none"
              }
            >
              <SchedaSearchBar />
              {searchOpen && (
                <button
                  type="button"
                  className="btn btn-link p-0 ms-2 mb-1 text-body"
                  aria-label="Chiudi ricerca"
                  onClick={() => setSearchOpen(false)}
                >
                  <FaTimes size={16} />
                </button>
              )}
            </div>
          )}
          <div>
            <ul className="navbar-nav d-flex flex-row align-items-center gap-3 gap-sm-4">
              {user && !searchOpen && (
                <li
                  role="button"
                  className="d-flex flex-column justify-content-center align-items-center nav-link"
                  onClick={() => setSearchOpen(true)}
                >
                  <FaSearch size={16} className="text-body p-0" />
                </li>
              )}
              {user && (
                <li className={`px-3 py-2 ${searchOpen ? "d-none" : ""}`}>
                  <Dropdown align="end">
                    <Dropdown.Toggle
                      as="div"
                      role="button"
                      id="notifications-dropdown"
                      className="position-relative d-flex align-items-center justify-content-center"
                      bsPrefix="notif-toggle"
                    >
                      <FaBell size={18} className="text-body" />
                      {unreadCount > 0 && (
                        <span
                          className="badge bg-danger rounded-pill position-absolute"
                          style={{ top: -4, right: -6, fontSize: "0.6rem" }}
                        >
                          {unreadCount > 9 ? "9+" : unreadCount}
                        </span>
                      )}
                    </Dropdown.Toggle>
                    <Dropdown.Menu style={{ minWidth: "320px", maxHeight: "420px", overflowY: "auto" }}>
                      <div className="d-flex align-items-center justify-content-between px-3 py-1">
                        <span className="text-sm font-weight-bold">Notifiche</span>
                        {unreadCount > 0 && (
                          <button
                            type="button"
                            className="btn btn-link btn-sm p-0 text-dark"
                            onClick={() => dispatch(markAllNotificationsRead())}
                          >
                            Segna tutte come lette
                          </button>
                        )}
                      </div>
                      <Dropdown.Divider />
                      {notifications.length === 0 ? (
                        <div className="px-3 py-2 text-secondary text-sm">Nessuna notifica</div>
                      ) : (
                        notifications.map((n) => (
                          <Dropdown.Item
                            key={n._id}
                            className={`text-wrap ${!n.read ? "bg-light" : ""}`}
                            onClick={() => !n.read && dispatch(markNotificationRead(n._id))}
                          >
                            <div className="text-sm text-dark">{n.message}</div>
                            <small className="text-secondary">{parseDate(n.createdAt)}</small>
                          </Dropdown.Item>
                        ))
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                </li>
              )}
              <li
                className={searchOpen ? "d-none" : ""}
                onClick={(e) => {
                  dispatch(closeMenu());
                }}
              >
                <NavLink
                  role="button"
                  to={`${user ? "/profile" : "/login"}`}
                  className="d-flex flex-column justify-content-center align-items-center nav-link"
                >
                  {user ? (
                    <>
                      <RandomColorCircle
                        letter={user?.email[0]}
                        email={user.email}
                      />
                      {/* <small className=""></small> */}
                    </>
                  ) : (
                    <>
                      <FaRegUserCircle size="20" className="text-body p-0" />
                      <small className="">Profile</small>
                    </>
                  )}
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Header;
